import React, { useEffect, useState, useRef } from 'react';
import { AppBar, Tabs, Tab, Box, Typography, useMediaQuery, IconButton, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import { getSportToggle } from '../../../store/slices/sportsSlice';

import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import styles from "./styles.module.css";
import carousel from '../../../images/carousel.png';
import carousel6 from '../../../images/carousel6.png';
import carousel4 from '../../../images/carousel4.png';
import carousel5 from '../../../images/carousel5.png';
import slider1 from '../../../images/slider1.png';
import slider3 from '../../../images/slider3.png';
import instantGameBanner from '../../../images/instantgame.jpeg';
import { GetAccessToBranch } from '../../../store/slices/branchAccessApi.js';


import age from '../../../images/18plus.png';
import git from '../../../images/gt.png';
import gamecare from '../../../images/gamecare.png';
import ssl from '../../../images/ssl.png';
import MatchCard from '../MatchCard/MatchCard.js';
import { CasinoData, electionData } from '../MatchCard/sports_Data.js';
import { useDispatch, useSelector } from 'react-redux';
import OtherGameGrid from '../OtherGameGrid/OtherGameGrid.js';
import Footer from '../../Footer/Footer.js';

import WhatsAppIcon from '../../../images/whatsapp-svgrepo-com.svg';
import { fetchMessage } from '../../../store/slices/messageSlice.js';
import { whatsapp } from '../../../store/slices/profileSlice.js';
import support from '../../../images/support.png';
import LoginScreen from '../../LoginScreen/LoginScreen.js';
import useMatch from '../../../api/userListingsocket.js';
import SupportChatWidget from '../../chat/SupportChatWidget.js'
import PasswordConfirmDialog from '../../PasswordConfirmDialog.js';
import aviatornew from '../../../images/aviatornew.jpeg';
import instantnew from '../../../images/instantnew.PNG';
import { postwithdrawsecuirty, postSetWithdrawSecurity, getWithdrawSecurityStatus, resetWithdrawSecurity } from '../../../store/slices/AccountSlice.js';


const tabs = [
    {
        label: 'Home',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M19.5702 10.9592C19.5698 10.9589 19.5695 10.9585 19.5691 10.9581L13.0417 4.43164C12.7635 4.15332 12.3936 4 12.0001 4C11.6066 4 11.2367 4.1532 10.9584 4.43152L4.43439 10.9547C4.43219 10.9569 4.42999 10.9592 4.42779 10.9614C3.85645 11.536 3.85742 12.4683 4.4306 13.0414C4.69247 13.3033 5.03833 13.4551 5.40812 13.4709C5.42314 13.4724 5.43827 13.4731 5.45353 13.4731H5.71369V18.2762C5.71369 19.2267 6.48709 20 7.43787 20H9.99159C10.2504 20 10.4604 19.7902 10.4604 19.5312V15.7656C10.4604 15.3319 10.8132 14.9791 11.247 14.9791H12.7532C13.187 14.9791 13.5398 15.3319 13.5398 15.7656V19.5312C13.5398 19.7902 13.7497 20 14.0086 20H16.5623C17.5131 20 18.2865 19.2267 18.2865 18.2762V13.4731H18.5277C18.9211 13.4731 19.291 13.3199 19.5695 13.0416C20.1433 12.4675 20.1435 11.5337 19.5702 10.9592Z" fill="currentColor" />
            </svg>
        ),
    },
    {
        label: 'InPlay', icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M21.0264 6.8738L19.0313 8.63398V15.366L21.0264 17.1262C21.4012 17.4568 22 17.1929 22 16.6869V7.31309C22 6.80989 21.4043 6.5404 21.0264 6.8738Z" fill="currentColor" />
                <path d="M13.6594 20C11.3023 21.1035 8.56015 21.1049 6.20007 20C5.90695 19.8628 5.55816 19.9892 5.42096 20.2822C5.28375 20.5753 5.41009 20.924 5.70318 21.0612C8.37521 22.3121 11.4807 22.3138 14.1563 21.0612C14.4494 20.924 14.5757 20.5753 14.4385 20.2822C14.3013 19.9891 13.9524 19.8628 13.6594 20Z" fill="currentColor" />
                <path d="M11.9116 19.3956C12.2242 19.3119 12.4098 18.9908 12.3262 18.6782C12.2426 18.3657 11.9213 18.18 11.6087 18.2637C10.519 18.5552 9.34909 18.5575 8.25064 18.2637C7.93807 18.18 7.61682 18.3657 7.53318 18.6782C7.44953 18.9908 7.63514 19.3119 7.94776 19.3956C9.22506 19.7373 10.6036 19.7455 11.9116 19.3956Z" fill="currentColor" />
                <path d="M6.20009 3.99993C8.5572 2.8965 11.2992 2.89505 13.6594 3.99993C13.953 4.13739 14.3016 4.0102 14.4385 3.71774C14.5757 3.4247 14.4494 3.07595 14.1563 2.93877C11.4841 1.68788 8.37882 1.68628 5.70319 2.93877C5.41011 3.07595 5.28373 3.42474 5.42097 3.71774C5.55822 4.01083 5.90701 4.13711 6.20009 3.99993Z" fill="currentColor" />
                <path d="M7.94776 4.60395C7.63514 4.68758 7.44953 5.00879 7.53318 5.32133C7.61682 5.6339 7.93803 5.81952 8.25064 5.73585C10.1506 5.22758 11.5427 5.75593 11.7605 5.75593C12.0193 5.75593 12.2561 5.5832 12.3261 5.32133C12.4098 5.00879 12.2242 4.68758 11.9115 4.60395C10.6268 4.26024 9.24799 4.2561 7.94776 4.60395Z" fill="currentColor" />
                <path d="M16.1015 6.7274H3.75782C2.78857 6.7274 2 7.51587 2 8.485V15.5154C2 16.4845 2.78857 17.273 3.75782 17.273H16.1015C17.0708 17.273 17.8594 16.4845 17.8594 15.5154V8.485C17.8594 7.51587 17.0708 6.7274 16.1015 6.7274ZM6.14064 14.6365H4.96879C4.64519 14.6365 4.38286 14.3742 4.38286 14.0507V9.94964C4.38286 9.62609 4.64519 9.36378 4.96879 9.36378C5.29238 9.36378 5.55471 9.62609 5.55471 9.94964V13.4648H6.14064C6.46424 13.4648 6.72657 13.7271 6.72657 14.0507C6.72657 14.3742 6.46424 14.6365 6.14064 14.6365ZM8.4844 14.0507C8.4844 14.3742 8.22206 14.6365 7.89847 14.6365C7.57487 14.6365 7.31254 14.3742 7.31254 14.0507V11.7072C7.31254 11.3837 7.57487 11.1214 7.89847 11.1214C8.22206 11.1214 8.4844 11.3837 8.4844 11.7072V14.0507ZM7.89847 10.5355C7.57487 10.5355 7.31254 10.2732 7.31254 9.94964C7.31254 9.62609 7.57487 9.36378 7.89847 9.36378C8.22206 9.36378 8.4844 9.62609 8.4844 9.94964C8.4844 10.2732 8.22206 10.5355 7.89847 10.5355ZM12.5771 10.1074L11.4306 14.2084C11.2732 14.7717 10.4733 14.783 10.3048 14.218L9.08204 10.117C8.98957 9.80694 9.16604 9.48062 9.47615 9.3882C9.78634 9.29566 10.1126 9.47218 10.2051 9.78226L10.8482 11.9392L11.4485 9.79194C11.5356 9.48035 11.859 9.29843 12.1705 9.38542C12.4821 9.47249 12.6641 9.79573 12.5771 10.1074ZM14.9297 11.3948C15.2533 11.3948 15.5156 11.6571 15.5156 11.9806C15.5156 12.3042 15.2533 12.5665 14.9297 12.5665H14.3438V13.4648H14.9297C15.2533 13.4648 15.5156 13.7271 15.5156 14.0507C15.5156 14.3742 15.2533 14.6365 14.9297 14.6365H13.7578C13.4342 14.6365 13.1719 14.3742 13.1719 14.0507V9.94964C13.1719 9.62609 13.4342 9.36378 13.7578 9.36378H14.9297C15.2533 9.36378 15.5156 9.62609 15.5156 9.94964C15.5156 10.2732 15.2533 10.5355 14.9297 10.5355H14.3438V11.3947L14.9297 11.3948Z" fill="currentColor" />
            </svg>
        ),
    },
    {
        label: 'Cricket', icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M16.5531 19.0433C16.1716 17.2077 17.1825 15.352 17.4835 13.5058C17.9889 12.9316 18.2035 12.1088 17.7573 11.249C16.4905 8.8016 14.5713 6.88802 12.7927 4.80222C11.0968 2.81273 8.21555 5.6829 9.90017 7.66014C10.4115 8.25964 10.9295 8.83915 11.4349 9.42191C11.4846 10.5483 11.4095 11.6648 10.8548 12.5843C10.5571 13.0781 10.7099 13.549 11.0388 13.851L10.6653 14.8464L10.022 14.6154L7.14242 22.0016C7.14242 22.0016 7.73679 23.8446 9.33 22.786C9.83797 21.4678 12.2092 15.4002 12.2092 15.4002L11.5656 15.1692L11.9387 14.1759C12.2451 14.1538 12.5448 14.0045 12.7485 13.6666C13.0787 13.1197 13.2848 12.5422 13.4109 11.9472C13.6968 12.3753 13.9681 12.8161 14.2098 13.285C14.3417 13.5388 14.5032 13.7372 14.6819 13.8918C14.3442 15.6397 13.5453 17.2738 13.8087 19.1286C14.0003 20.4778 14.4014 21.8016 14.8676 23.0823C15.4553 24.6987 18.1033 24.0021 17.5097 22.3701C17.1157 21.285 16.7872 20.1733 16.5531 19.0433Z" fill="currentColor" />
                <path d="M7.48343 2.19568C7.49428 2.31158 7.51307 2.4283 7.54604 2.5442C7.56733 2.62051 7.59363 2.69356 7.62326 2.76498L7.02847 3.2445C6.9788 3.28449 6.97087 3.35713 7.01219 3.4057C7.05936 3.46324 8.05735 4.64347 8.98606 4.39534C9.10961 4.36229 9.23191 4.30352 9.35129 4.21414C9.36131 4.2068 9.37007 4.1966 9.378 4.18599L9.48485 4.02601C9.67936 4.03009 9.87721 4.00846 10.0751 3.95623C11.1716 3.66321 11.8177 2.55603 11.5184 1.48314C11.2187 0.410649 10.0872 -0.22109 8.98982 0.0715177C8.14543 0.297197 7.57025 1.00484 7.48552 1.80758L6.41448 2.09366L6.51507 2.45401L7.48343 2.19568ZM9.21855 4.00275L9.19142 4.04397C8.8742 4.2725 8.5094 4.21333 8.17798 4.05213L8.46306 3.73259C8.69305 3.86889 8.94933 3.96194 9.21855 4.00275ZM8.26856 3.60036L7.98932 3.91378C7.98222 3.92194 7.9768 3.92888 7.9722 3.93745C7.6579 3.74034 7.3962 3.47956 7.27265 3.34652L7.72803 2.97923C7.86535 3.2245 8.04984 3.43426 8.26856 3.60036Z" fill="currentColor" />
                <path d="M6.47458 11.2963C6.21246 11.2963 6 11.504 6 11.7603V20.9475C6 21.2034 6.21246 21.4115 6.47458 21.4115C6.73671 21.4115 6.94875 21.2034 6.94875 20.9475V11.7603C6.94875 11.504 6.73712 11.2963 6.47458 11.2963Z" fill="currentColor" />
                <path d="M8.82996 11.7603C8.82996 11.504 8.61792 11.2963 8.35579 11.2963C8.09325 11.2963 7.88079 11.504 7.88079 11.7603V18.8519L8.82996 16.418V11.7603Z" fill="currentColor" />
                <path d="M10.7045 11.8399V11.7607C10.7045 11.5044 10.4925 11.2967 10.2299 11.2967C9.96737 11.2967 9.75533 11.5044 9.75533 11.7607V14.0441L9.80249 13.9229L10.4378 14.1518L10.4424 14.1416C10.1101 13.6196 10.1018 12.9781 10.4449 12.4104C10.5526 12.2301 10.6369 12.0387 10.7045 11.8399Z" fill="currentColor" />
                <path d="M8.19676 11.049C8.19676 10.9119 8.08365 10.8017 7.94424 10.8017H6.72878C6.58811 10.8017 6.475 10.9123 6.475 11.049C6.475 11.1857 6.58811 11.2967 6.72878 11.2967H7.94424C8.08365 11.2963 8.19676 11.1857 8.19676 11.049Z" fill="currentColor" />
                <path d="M9.97697 10.8013H8.76109C8.62084 10.8013 8.50731 10.9119 8.50731 11.0486C8.50731 11.1853 8.62084 11.2963 8.76109 11.2963H9.97697C10.1168 11.2963 10.2295 11.1853 10.2295 11.0486C10.2299 10.9119 10.1168 10.8013 9.97697 10.8013Z" fill="currentColor" />
            </svg>
        ),
    },

    {
        label: 'Casino', icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clip-path="url(#clip0_5095_14598)">
                    <path d="M3.464 20.424C3.48 20.444 3.496 20.464 3.516 20.484C3.532 20.5 3.552 20.516 3.572 20.528C3.572 20.528 3.576 20.536 3.58 20.536C5.732 22.66 8.672 23.976 11.92 23.992C11.932 23.996 11.944 23.996 11.96 23.996C11.972 24 11.988 24 12 24C12.012 24 12.028 24 12.04 23.996C12.056 23.996 12.068 23.996 12.08 23.992C15.344 23.976 18.3 22.644 20.452 20.508C20.464 20.5 20.472 20.492 20.48 20.484C20.5 20.464 20.516 20.444 20.532 20.424C22.68 18.256 24 15.28 24 12V11.996C24 8.716 22.676 5.74 20.532 3.576C20.516 3.556 20.5 3.536 20.48 3.52C20.476 3.512 20.468 3.504 20.46 3.5C20.46 3.49733 20.4587 3.496 20.456 3.496C18.288 1.336 15.296 0 12 0C8.704 0 5.748 1.32 3.58 3.46C3.58 3.46 3.58 3.464 3.576 3.464C3.556 3.48 3.536 3.496 3.516 3.516C3.496 3.536 3.48 3.556 3.464 3.576C3.464 3.58 3.46 3.58 3.46 3.58C1.32 5.744 0 8.72 0 11.996V12C0 15.28 1.32 18.252 3.46 20.42C3.46 20.42 3.464 20.42 3.464 20.424ZM12.4 23.184V20.424C14.372 20.336 16.22 19.572 17.676 18.248L19.624 20.192C17.716 21.972 15.184 23.092 12.4 23.184ZM20.192 4.372C21.972 6.28 23.092 8.812 23.188 11.596H20.42C20.332 9.624 19.568 7.776 18.244 6.32L20.192 4.372ZM11.6 0.808V3.572C9.632 3.664 7.784 4.428 6.32 5.756L4.372 3.808C6.28 2.028 8.812 0.904 11.6 0.808ZM6.596 6.6C8.036 5.168 9.94 4.376 11.96 4.364H11.968C11.98 4.368 11.988 4.368 12 4.368C12.012 4.368 12.02 4.368 12.032 4.364H12.04C14.056 4.376 15.952 5.16 17.38 6.58L17.384 6.584C17.388 6.588 17.396 6.596 17.4 6.6C17.404 6.604 17.412 6.612 17.412 6.616C18.844 8.052 19.632 9.964 19.632 11.996C19.632 14.028 18.84 15.956 17.4 17.4L17.396 17.404C15.964 18.832 14.064 19.624 12.04 19.636H12.032C12.02 19.632 12.012 19.632 12 19.632C11.988 19.632 11.98 19.632 11.968 19.636H11.96C9.94 19.624 8.036 18.832 6.596 17.4C5.156 15.956 4.364 14.036 4.364 11.996C4.364 9.956 5.156 8.04 6.596 6.6ZM3.576 12.396C3.664 14.368 4.428 16.216 5.756 17.68L3.808 19.628C2.028 17.72 0.904 15.188 0.812 12.396H3.576Z" fill="currentColor" />
                    <path d="M10.2039 15.3317C10.5559 15.3317 10.9079 15.2717 11.2399 15.1477L10.5719 16.9718C10.5279 17.0958 10.5439 17.2317 10.6199 17.3397C10.6959 17.4437 10.8159 17.5077 10.9479 17.5077H13.0519C13.1839 17.5077 13.3079 17.4437 13.3799 17.3397C13.4559 17.2317 13.4719 17.0958 13.4279 16.9718L12.7599 15.1477C13.8239 15.5397 15.0679 15.3078 15.9119 14.4598C17.0599 13.3158 17.0759 11.4358 15.9439 10.2677L12.2839 6.60775C12.1319 6.45575 11.8679 6.45575 11.7159 6.60775L8.05987 10.2677C8.05721 10.2677 8.05454 10.2691 8.05187 10.2718C7.51187 10.8317 7.21187 11.5717 7.21187 12.3477C7.21587 13.1477 7.52387 13.8998 8.08787 14.4598C8.66787 15.0398 9.43587 15.3317 10.2039 15.3317Z" fill="currentColor" />
                </g>
                <defs>
                    <clipPath id="clip0_5095_14598">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        ),
    },
];

// const carouselImages = [slider1, slider3];
const carouselImages = [aviatornew, instantnew];

const Home = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery('(max-width:1023px)');

    const [userFlag, setUserFlag] = useState(null); // add this
    const [tabIndex, setTabIndex] = useState(0);
    const { authenticated } = useSelector((state) => state.auth);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [showSupport, setShowSupport] = useState(false);
    const [supportUnreadCount, setSupportUnreadCount] = useState(0);
    const { text: marqueeText, loading: messageLoading } = useSelector(
        (state) => state.message
    );

    // ✅ Marquee speed: duration = (box width + text width) / speed
    const MARQUEE_SPEED = 40; // px per second (zyada = fast, kam = slow)
    const marqueeRef = useRef(null);
    const [marqueeDur, setMarqueeDur] = useState(10);

    useEffect(() => {
        const el = marqueeRef.current;
        if (el) setMarqueeDur(el.offsetWidth / MARQUEE_SPEED);
    }, [marqueeText, authenticated, tabIndex]);

const isAuthenticated = useSelector((state) => state.auth.authenticated);
const sportToggleData = useSelector((state) => state.sports?.getSportToggleData ?? []);
const casinoEnabled = sportToggleData.some(
    (item) => Number(item.etid) === 12 && (item.enabled === true || item.enabled === "true")
);
    // ✅ For Deposit/Withdraw buttons moved here from Header
    const navigate = useNavigate();
    const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);
    const [withdrawAnchor, setWithdrawAnchor] = useState(null);



      const handledepositOpen = () => navigate('/deposit');
    const handleWithdrawOpen = () => navigate('/withdraw');
    // const handlePasswordConfirm = () => {
    //     setPasswordDialogOpen(false);
    //     setWithdrawAnchor(null);
    //     navigate('/withdraw');
    // };


    const handlePasswordConfirm = async (password, confirmPassword) => {
        try {
            if (userFlag === 0) {
                // New user — set-tpin
                await dispatch(postSetWithdrawSecurity({
                    transactionPassword: String(password),
                    confirmPassword: String(confirmPassword)
                })).unwrap();
            } else if (userFlag === 1) {
                // Existing user — verify-tpin
                await dispatch(postwithdrawsecuirty({
                    transactionPassword: String(password),
                    confirmPassword: String(confirmPassword)
                })).unwrap();
            } else if (userFlag === 2) {
                // Reset password
                await dispatch(resetWithdrawSecurity({
                    transactionPassword: String(password),
                    confirmPassword: String(confirmPassword)
                })).unwrap();
            }
            setPasswordDialogOpen(false);
            setWithdrawAnchor(null);
            navigate('/withdraw');
        } catch (error) {
            console.error('Failed:', error);
            alert(error?.message || 'Something went wrong!');
        }
    };

    const tabToEtid = (idx) => {
        const map = {
            2: 4,
            3: 1,
            4: 2,
            6: 66,
        };
        return map[idx];
    };


    const { matchData: sportsFeed, loading, error } = useMatch();


    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchMessage());
    }, [dispatch]);

    useEffect(() => {
        dispatch(getSportToggle());
    }, [dispatch]);

    
    const { userId } = useSelector((state) => state.auth);
const [branchEnabled, setBranchEnabled] = useState(true);

useEffect(() => {
    console.log("HOME userId:", userId);
    if (!userId) return;

    const check = () => {
        dispatch(GetAccessToBranch(userId))
            .unwrap()
            .then((data) => {
                console.log("BRANCH RESPONSE:", data);
                const value = data?.branchValue ?? data?.enableAdmins ?? true;
                setBranchEnabled(value !== false);
            })
            .catch((err) => console.error("BRANCH ERROR:", err));
    };

    check();
    const id = setInterval(check, 30000);
    return () => clearInterval(id);
}, [dispatch, userId]);
const disabledLinkSx = branchEnabled
    ? {}
    : { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' };

const blockIfDisabled = (e) => {
    if (!branchEnabled) e.preventDefault();
};
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % carouselImages.length);
        }, 3000);
        return () => clearInterval(intervalId);
    }, []);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselImages.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + carouselImages.length) % carouselImages.length);
    };

    const goToSlide = (index) => {
        setCurrentIndex(index);
    };

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };


// League-object ko flat match array mein convert karta hai, cname preserve karte hue
const flattenLeagueData = (leagueObj) => {
    if (!leagueObj || typeof leagueObj !== 'object') return [];
    return Object.entries(leagueObj).flatMap(([leagueName, matches]) =>
        (Array.isArray(matches) ? matches : []).map(m => ({
            ...m,
            cname: m.cname || leagueName
        }))
    );
};
const stripDateFromEventName = (name) => {
    if (!name) return name;
    return name.split('/')[0].trim();
};
const sortMatches = (matches) => {
    return [...matches].sort((a, b) => {
        if (a.live && !b.live) return -1;
        if (!a.live && b.live) return 1;

        const dateA = new Date(a.rawStartTime || a.date).getTime();
        const dateB = new Date(b.rawStartTime || b.date).getTime();

        if (isNaN(dateA) && isNaN(dateB)) return 0;
        if (isNaN(dateA)) return 1;
        if (isNaN(dateB)) return -1;

        return dateA - dateB;
    });
};


const mapRow = (row) => {
      console.log('mapRow beventId:', row.beventId, 'row:', row);
    const rawSections = (row?.sections?.length ? row.sections : row?.section) || [];
    if (!rawSections.length) return null;

    let activeSections = rawSections
        .map((s, idx) => ({ ...s, _idx: idx }))
        .filter(s => s.gstatus === "ACTIVE" || s.gstatus === null)
        .sort((a, b) => a._idx - b._idx);

    if (activeSections.length < 2) {
        activeSections = rawSections
            .map((s, idx) => ({ ...s, _idx: idx }))
            .sort((a, b) => a._idx - b._idx);
    }

    const allOdds = activeSections.flatMap(s => s.odds || []);

    const t1Back = allOdds.find(o => o.otype === 'back' && o.tno === 1)?.odds?.toFixed(2) || '0';
    const t1Lay = allOdds.find(o => o.otype === 'lay' && o.tno === 1)?.odds?.toFixed(2) || '0';
    const t2Back = allOdds.find(o => o.otype === 'back' && o.tno === 2)?.odds?.toFixed(2) || '0';
    const t2Lay = allOdds.find(o => o.otype === 'lay' && o.tno === 2)?.odds?.toFixed(2) || '0';
    const t3Back = allOdds.find(o => o.otype === 'back' && o.tno === 3)?.odds?.toFixed(2) || '0';
    const t3Lay = allOdds.find(o => o.otype === 'lay' && o.tno === 3)?.odds?.toFixed(2) || '0';

    const odds = [t1Back, t1Lay, t3Back, t3Lay, t2Back, t2Lay];

    const rawStartTime = row.startTime || row.stime || null;

    return {
        date: rawStartTime ? new Date(rawStartTime).toLocaleString() : '—',
        rawStartTime, // keep raw value for sorting
        live: !!row.inPlay || !!row.iplay,
        teams: stripDateFromEventName(row.eventName || row.ename || row.mname || row.cname || '—'),
        tags: [
            row.f ? 'F' : null,
            row.m1 ? 'BM' : null,
            row.tv ? 'TV' : null,
        ].filter(Boolean),
        odds,
        etid: row.etid,
        cname: row.cname,
        gmid: row.gmid || row.gameId || row.mid || 0,
        // beventId: row.gameId || null,
        beventId: row.beventId ,
        status: row.status || row.gstatus || (row.inPlay ? 'LIVE' : 'OPEN')
    };
};


// const getFilteredData = (tabIndex) => {
//     const cricketIcon = tabs.find(tab => tab.label === 'Cricket')?.icon;
//     const footballIcon = tabs.find(tab => tab.label === 'Football')?.icon;
//     const tennisIcon = tabs.find(tab => tab.label === 'Tennis')?.icon;
//     const kabaddiIcon = tabs.find(tab => tab.label === 'Kabaddi')?.icon;

//     const EXCLUDED_MATCHES = [
//         { eventName: "Ireland v Afghanistan" }
//     ];

//     const isExcludedMatch = (m) => {
//         return EXCLUDED_MATCHES.some(ex =>
//             (m.eventName || m.ename || '').includes(ex.eventName)
//         );
//     };

//     const t1Flat = flattenLeagueData(sportsFeed?.data).filter(m => !isExcludedMatch(m));
//     const t2Flat = flattenLeagueData(sportsFeed?.data?.t2).filter(m => !isExcludedMatch(m));
    

//     const allMatches = [
//         ...t1Flat,
//         ...(tabIndex === 1 ? t2Flat : [])
//     ];

//     const mapped = sortMatches(allMatches.map(mapRow).filter(Boolean));

//     if (tabIndex === 0) {
//         return [{ title: 'Cricket', data: mapped, icon: cricketIcon }];
//     }

//     if (tabIndex === 1) {
//         const liveMatches = mapped.filter(m => m.live);
//         if (liveMatches.length === 0) return [];
//         return [{ title: 'InPlay', data: liveMatches, icon: cricketIcon }];
//     }

//     const perTab = {
//         2: { title: 'Cricket', icon: cricketIcon },
//         3: { title: 'Casino', icon: tabs.find(t => t.label === 'Casino')?.icon, data: CasinoData },
//         4: { title: 'Tennis', icon: tennisIcon },
//         6: { title: 'Kabaddi', icon: kabaddiIcon },
//         5: { title: 'Casino', icon: tabs.find(t => t.label === 'Casino')?.icon, data: CasinoData },
//         7: { title: 'Election', icon: tabs.find(t => t.label === 'Election')?.icon, data: electionData },
//     }[tabIndex];

//     if (!perTab) return [];
//     if (perTab.data) return [{ title: perTab.title, data: perTab.data, icon: perTab.icon }];

//     return [{ title: perTab.title, data: mapped, icon: perTab.icon }];
// };


const getFilteredData = (tabLabel) => {
    const cricketIcon = tabs.find(tab => tab.label === 'Cricket')?.icon;
    const casinoIcon = tabs.find(tab => tab.label === 'Casino')?.icon;

    const EXCLUDED_MATCHES = [
        { eventName: "Ireland v Afghanistan" }
    ];

    const isExcludedMatch = (m) => {
        return EXCLUDED_MATCHES.some(ex =>
            (m.eventName || m.ename || '').includes(ex.eventName)
        );
    };

    const t1Flat = flattenLeagueData(sportsFeed?.data).filter(m => !isExcludedMatch(m));
    const t2Flat = flattenLeagueData(sportsFeed?.data?.t2).filter(m => !isExcludedMatch(m));

    const allMatches = [
        ...t1Flat,
        ...(tabLabel === 'InPlay' ? t2Flat : [])
    ];

    const mapped = sortMatches(allMatches.map(mapRow).filter(Boolean));

    if (tabLabel === 'Home') {
        return [{ title: 'Cricket', data: mapped, icon: cricketIcon }];
    }

    if (tabLabel === 'InPlay') {
        const liveMatches = mapped.filter(m => m.live);
        if (liveMatches.length === 0) return [];
        return [{ title: 'InPlay', data: liveMatches, icon: cricketIcon }];
    }

    if (tabLabel === 'Cricket') {
        return [{ title: 'Cricket', data: mapped, icon: cricketIcon }];
    }

    if (tabLabel === 'Casino') {
        return [{ title: 'Casino', data: CasinoData, icon: casinoIcon }];
    }

    return [];
};

    const location = useLocation();
        const visibleTabs = tabs.filter((tab) => tab.label !== 'Casino' || casinoEnabled);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    useEffect(() => {
        if (authenticated) setShowLoginModal(false);
        setShowSupport(false);
    }, [authenticated]);

    useEffect(() => {
        const handler = () => setShowLoginModal(true);
        window.addEventListener('openLoginModal', handler);
        return () => window.removeEventListener('openLoginModal', handler);
    }, []);

    return (
        <Box className={styles.Main_Container}>

            {!authenticated && showLoginModal && (
                <>
                    <Box
                        sx={{
                            position: 'fixed',
                            inset: 0,
                            backdropFilter: 'blur(6px)',
                            backgroundColor: 'rgba(0,0,0,0.55)',
                            zIndex: 1000,
                        }}
                    />
                    <Box
                        sx={{
                            position: 'fixed',
                            inset: 0,
                            zIndex: 1001,
                            display: 'flex',
                            alignItems: 'flex-start',
                            justifyContent: 'center',
                        }}
                    >
                        <LoginScreen onLoginSuccess={() => { }} />
                    </Box>
                </>
            )}
{/* {!isAuthenticated && (
    <>
         <a
            rel="noopener noreferrer"
            className={styles.help}
            onClick={() => {
                setShowSupport(true);
                setSupportUnreadCount(0);
            }}
            style={{ cursor: 'pointer' }}
        >
            <img src={support} alt="support" />
            {!showSupport && supportUnreadCount > 0 && (
                <span style={{
                    position: 'absolute',
                    top: '-4px',
                    right: '-4px',
                    background: '#fd0000',
                    color: '#fff',
                    fontSize: '13px',
                    fontWeight: '600',
                    borderRadius: '999px',
                    minWidth: '18px',
                    height: '18px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 4px',
                    lineHeight: '1',
                }}>
                    {supportUnreadCount > 99 ? '99+' : supportUnreadCount}
                </span>
            )}
        </a>
        <SupportChatWidget
            open={showSupport}
            onClose={() => setShowSupport(false)}
            onUnread={(count) => setSupportUnreadCount(count)}
        />
    </> 
)} */}

 {/* <a
                href="https://wa.link/mewin01"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.help}
                style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box
                    sx={{
                        width: 58,
                        height: 58,
                        borderRadius: '50%',
                        backgroundColor: '#25D366',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 4px 10px rgba(0,0,0,0.25)',
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.148.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"
                            fill="#fff"
                        />
                        <path
                            d="M12.004 2C6.486 2 2 6.486 2 12.004c0 1.887.52 3.653 1.42 5.164L2 22l4.955-1.396A9.945 9.945 0 0012.004 22C17.522 22 22 17.522 22 12.004 22 6.486 17.522 2 12.004 2zm0 18.09a8.08 8.08 0 01-4.14-1.135l-.297-.176-2.94.828.833-2.867-.194-.297a8.08 8.08 0 01-1.264-4.44c0-4.47 3.632-8.104 8.102-8.104 4.47 0 8.102 3.634 8.102 8.104 0 4.47-3.632 8.087-8.102 8.087z"
                            fill="#fff"
                        />
                    </svg>
                </Box>
            </a> */}


            <AppBar position="static" className={styles.tabBar}>
                <Box sx={{ maxWidth: '1440px !important', padding: '1px' }}>
                                      <Tabs
                        value={tabIndex}
                        onChange={handleTabChange}
                        variant={isMobile ? 'scrollable' : 'standard'}
                        scrollButtons={isMobile ? 'auto' : false}
                        className={styles.tabs}
                        TabIndicatorProps={{ style: { display: 'none' } }}
                    >
                        {visibleTabs.map((tab, index) => (
                            <Tab
                                key={index}
                                className={`${styles.tabItem} ${tabIndex === index ? styles.activeTabItem : ''}`}
                                icon={tab.icon}
                                iconPosition="start"
                                label={tab.label}
                            />
                        ))}
                    </Tabs>
                </Box>
            </AppBar>

            {/* ✅ Marquee row — Deposit/Withdraw on LEFT, marquee text on RIGHT */}
           <Box className={styles.marqueeContainer}>
    {/* Message: left side, apne clipped box mein */}
    <Box className={styles.marqueeViewport}>
        <Typography
            ref={marqueeRef}
            className={styles.marqueeText}
            style={{ animationDuration: `${marqueeDur}s` }}
        >
            {messageLoading ? '' : marqueeText}
        </Typography>
    </Box>

    {/* Buttons: right side, hamesha poore dikhenge */}
    {authenticated && (
        <Box className={styles.action_buttons_container}>
            <Box sx={{ width: '1px', height: '27px', background: '#fff', flexShrink: 0, margin: '0 4px' }} />

            <Button
                className={`${styles.Deposit_btn} ${styles.action_btn}`}
                onClick={handledepositOpen}
                disabled={!branchEnabled}
                sx={!branchEnabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                size="small"
            >
                <Typography className={styles.Add_btn_txt}>Deposit</Typography>
            </Button>

            <Button
                className={`${styles.Withdraw_btn} ${styles.action_btn}`}
                onClick={handleWithdrawOpen}
                disabled={!branchEnabled}
                sx={!branchEnabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                size="small"
            >
                <Typography className={styles.Add_btn_txt}>Withdraw</Typography>
            </Button>
        </Box>
    )}
</Box>

            {/* ✅ PasswordConfirmDialog for  */}
            <PasswordConfirmDialog
                open={passwordDialogOpen}
                anchorEl={withdrawAnchor}
                flag={userFlag}
                onResetPassword={() => setUserFlag(0)}
                onClose={() => { setPasswordDialogOpen(false); setWithdrawAnchor(null); }}
                onConfirm={handlePasswordConfirm}
            />

             {/* {tabIndex === 0 && branchEnabled && ( */}
             {tabIndex === 0 && (
                <Box className={styles.carouselWrapper}>
                    <Box className={styles.carouselWrapper_inner}>
                        <IconButton
                            className={styles.navButton}
                            onClick={prevSlide}
                            disabled={currentIndex === 0}
                        >
                            <ArrowBackIos />
                        </IconButton>

                        <Box>
                            <img
                                src={carouselImages[currentIndex]}
                                alt="carousel"
                                className={styles.carouselImage}
                                style={{ width: '100%', borderRadius: '8px', height: '100%' }}
                            />
                        </Box>

                        <IconButton
                            className={styles.navButton}
                            onClick={nextSlide}
                            disabled={currentIndex === carouselImages.length - 1}
                        >
                            <ArrowForwardIos />
                        </IconButton>
                    </Box>
                    <Box className={styles.dotsContainer}>
                        {carouselImages.map((_, index) => (
                            <span
                                key={index}
                                className={`${styles.dot} ${currentIndex === index ? styles.activeDot : ''}`}
                                onClick={() => goToSlide(index)}
                            />
                        ))}
                    </Box>
                </Box>
            )}
{/* 
            {tabIndex === 0 && !branchEnabled && (
    <Box className={styles.carouselWrapper}>
        <Box className={styles.carouselWrapper_inner}>
            <img
                src={instantGameBanner}
                alt="Mewin Instant Game"
                className={styles.carouselImage}
                style={{ width: '100%', borderRadius: '8px', height: '100%' }}
            />
        </Box>
    </Box>
)} */}

                     <Box className={styles.MatchCardContainer} sx={{ marginBottom: '6px' }}>
                {loading ? (
                    <Typography></Typography>
                ) : sportsFeed ? (
                    getFilteredData(visibleTabs[tabIndex]?.label).map(({ title, data, icon }, i) => (
                        <MatchCard key={i} title={title} icon={icon} data={data} />
                    ))
                ) : (
                    <Typography></Typography>
                )}
            </Box>

            <Box className={styles.OtherGameGridContainer}>
                <OtherGameGrid />
            </Box>

            {/* <Box className={styles.FooterContainer}>
                <Footer />
            </Box> */}
            {/* <Box className={styles.FooterContainer}> */}
    <Box
        sx={{
           background: 'linear-gradient(135deg, #0a7fc2 0%, #0a5f9c 100%)',
    padding: '10px 16px',
    textAlign: 'center',
    width: '100%',
    alignSelf: 'stretch',
    boxSizing: 'border-box',
    maxWidth: '100%',
        }}
    >
        <Typography
            sx={{
                color: '#fff',
                fontWeight: 700,
                fontSize: '20px',
               
            }}
        >
            24X7 Support
        </Typography>
   <Typography
    component="a"
    href="https://wa.link/mewin01"
    target="_blank"
    rel="noopener noreferrer"
    onClick={blockIfDisabled}
    aria-disabled={!branchEnabled}
    sx={{
        color: 'rgba(255,255,255,0.85)',
        fontSize: '13px',
        mb: 1,
        display: 'inline-block',
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            color: '#fff',
        },
        ...disabledLinkSx,
    }}
>
     https://wa.link/mewin01
</Typography>
     <Box
    component="a"
    href="https://wa.link/mewin01"
    target="_blank"
    rel="noopener noreferrer"
    onClick={blockIfDisabled}
    aria-disabled={!branchEnabled}
    sx={{
        width: 30,
        height: 30,
        borderRadius: '50%',
        backgroundColor: '#25D366',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto',
        cursor: 'pointer',
        boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
        textDecoration: 'none',
        ...disabledLinkSx,
    }}
>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path
            d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.148.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"
            fill="#fff"
        />
        <path
            d="M12.004 2C6.486 2 2 6.486 2 12.004c0 1.887.52 3.653 1.42 5.164L2 22l4.955-1.396A9.945 9.945 0 0012.004 22C17.522 22 22 17.522 22 12.004 22 6.486 17.522 2 12.004 2zm0 18.09a8.08 8.08 0 01-4.14-1.135l-.297-.176-2.94.828.833-2.867-.194-.297a8.08 8.08 0 01-1.264-4.44c0-4.47 3.632-8.104 8.102-8.104 4.47 0 8.102 3.634 8.102 8.104 0 4.47-3.632 8.087-8.102 8.087z"
            fill="#fff"
        />
    </svg>
</Box>
    </Box>

    <Box
        sx={{
            background: '#fff',
            padding: '20px 16px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1.5,
        }}
    >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="none">
                <path
                    d="M12 2L4 5V11C4 16.5 7.5 21.2 12 22C16.5 21.2 20 16.5 20 11V5L12 2Z"
                    fill="#22c55e"
                />
                <path
                    d="M9 12L11 14L15.5 9.5"
                    stroke="#fff"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg> */}
            {/* <Box sx={{ textAlign: 'left' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#212121' }}>
                    SECURE
                </Typography>
                <Typography sx={{ fontSize: '10px', color: '#888' }}>
                    SSL ENCRYPTION
                </Typography>
            </Box>
            <Box sx={{ textAlign: 'left', ml: 1 }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#212121' }}>
                    100% SAFE
                </Typography>
                <Typography sx={{ fontSize: '11px', color: '#888' }}>
                    Protected connection and encrypted data.
                </Typography>
            </Box>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
                sx={{
                    width: 30,
                    height: 30,
                    borderRadius: '50%',
                    border: '2px solid #d32f2f',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '11px',
                    fontWeight: 700,
                    color: '#d32f2f',
                }}
            >
                18+
            </Box> */}
<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, px: 2, py: 1.5, mt: -5 }}>

  {/* Top row: SSL icon + text */}
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: -2 }}>
    <Box
      component="img"
      src={ssl}
      alt="Secure SSL"
      sx={{ width: 110, height: 110, objectFit: 'contain', flexShrink: 0 }}
    />

    <Box sx={{ textAlign: 'left' }}>
      <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#212121', lineHeight: 1.3 }}>
        100% SAFE
      </Typography>
      <Typography sx={{ fontSize: '10px', color: '#000', lineHeight: 1.3 }}>
        Protected connection and encrypted data.
      </Typography>
    </Box>
  </Box>

  {/* Bottom row: 18+, GamCare, GT badges - CENTERED */}
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, width: '100%',mt:-4 ,mb:-5}}>
    <Box
      component="img"
      src={age}
      alt="18+"
      sx={{
        width: 30,
        height: 30,
        borderRadius: '50%',
        border: '2px solid #d32f2f',
        objectFit: 'cover',
      }}
    />
    <Box
      component="img"
      src={gamecare}
      alt="GamCare"
      sx={{ width: 30, height: 30, borderRadius: '50%', objectFit: 'cover' }}
    />
    <Box
      component="img"
      src={git}
      alt="GT"
      sx={{ width: 30, height: 30, borderRadius: '50%', objectFit: 'cover' }}
    />
  </Box>

</Box>
        </Box>
    </Box>
</Box>
      

    );
};

export default Home;